// extracted by mini-css-extract-plugin
export default {"error":"ApiError_error__kokN7"};